import axios from 'axios';
//const token = localStorage.getItem('9asset_token');
import { auth } from '../firebase/index';
const axiosInstance = axios.create();

// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        if (!config['headers']) {
          config['headers'] = {};
        }
        config['headers']['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error fetching Firebase ID token:', error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      //window.location.href = '/login';
    }

    return Promise.reject(error);
  },
);

export const _axios = axiosInstance;
export const cancelToken = axios.CancelToken;

export const customFetch = async (url: URL | string, options: RequestInit = {}): Promise<Response> => {
  const urlString = url instanceof URL ? url.toString() : url;

  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;

  const mergedOptions: RequestInit = {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };

  return fetch(urlString, mergedOptions);
};
